<mat-card>
  <mat-card-header class="container between mb-1">


    <h4 matCardTitle>Töiden luokittelu, kohteessa
      @if (project | async; as currentProject) {
        @if (currentProject) {
          <span>{{ currentProject.name }}</span>
        }
        @if (!currentProject) {
          <span><mat-icon>account_tree</mat-icon></span>
        }
      }

    </h4>
    <h6 matCardSubtitle>Nämä vaihtoehdot käytettävissä työtuntien kirjauslomakkeella tarkentamaan raportointia</h6>
    @if (linkedTemplateId !== null) {
      <div class="template-chip-row">
        <span class="status-indicator active template-chip">
          <mat-icon class="icon-sm">link</mat-icon>
          {{ (linkedTemplateName ? 'WORKCLASSIFICATION.TEMPLATES.TREE.LINKED_TO' : 'WORKCLASSIFICATION.TEMPLATES.TREE.LINKED') | translate: { name: linkedTemplateName } }}
        </span>
      </div>
    }
    <!-- <div>

    <mat-card-subtitle>
      Alla kirjaustarkennukset työmaalle {{ (project|async)?.name }}
    </mat-card-subtitle>
  </div> -->

  <div class="container">

    <button mat-raised-button class="btn-secondary" (click)="exportTreeToPDF()" [disabled]="classifications.length === 0 || isExporting">
      <mat-icon>picture_as_pdf</mat-icon>
      {{ 'WORKCLASSIFICATION.EXPORTPDF' | translate }}
    </button>
    <button mat-raised-button class="btn-primary" [disabled]="loading" (click)="addSubClassification(null)"><mat-icon>add</mat-icon> {{ 'WORKCLASSIFICATION.TEMPLATES.TREE.ADD_NEW' | translate }}</button>
    <button mat-raised-button class="btn-secondary" [disabled]="loading" (click)="copyAllClassifications()"><mat-icon>content_copy</mat-icon> {{ 'WORKCLASSIFICATION.TEMPLATES.TREE.COPY_TO_OTHER' | translate }}</button>
    @if (!loading && classifications.length > 0 && linkedTemplateId !== null) {
      <button *hasPermission="permissions.WorkClassificationPermissions.CanManageWorkClassification" mat-stroked-button class="btn-secondary" (click)="openSyncFromTemplate()">
        <mat-icon>sync</mat-icon> {{ 'WORKCLASSIFICATION.TEMPLATES.TREE.SYNC_FROM_TEMPLATE' | translate }}
      </button>
    }
    @if (!loading && classifications.length > 0 && linkedTemplateId === null) {
      <button *hasPermission="permissions.WorkClassificationPermissions.CanManageWorkClassification" mat-stroked-button class="btn-secondary" (click)="openLinkTemplate()">
        <mat-icon>link</mat-icon> {{ 'WORKCLASSIFICATION.TEMPLATES.TREE.LINK_TO_TEMPLATE' | translate }}
      </button>
    }
  </div>



</mat-card-header>
<mat-card-content>

  @if (loading && classifications.length === 0) {
    <div class="table-loading"><mat-spinner diameter="32"></mat-spinner></div>
  } @else if (!loading && classifications.length === 0) {
    <div class="no-data empty-tree">
      <mat-icon>account_tree</mat-icon>
      <h3>{{ 'WORKCLASSIFICATION.TEMPLATES.TREE.EMPTY_TITLE' | translate }}</h3>
      <ng-container *hasPermission="[permissions.WorkClassificationPermissions.CanAddWorkClassification, permissions.WorkClassificationPermissions.CanManageWorkClassification]">
        <p>{{ 'WORKCLASSIFICATION.TEMPLATES.TREE.EMPTY_HINT' | translate }}</p>
        <div class="app-row center empty-tiles">
          <mat-card class="info-card app-col">
            <mat-card-content class="empty-tile">
              <mat-icon class="title-icon">auto_awesome</mat-icon>
              <h4>{{ 'WORKCLASSIFICATION.TEMPLATES.TREE.USE_TEMPLATE' | translate }}</h4>
              @if (templates.length > 0) {
                <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.TREE.USE_TEMPLATE_DESC' | translate }}</p>
              } @else if (templatesFailed) {
                <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.LOAD_FAILED' | translate }}</p>
                <button mat-button class="btn-tertiary" (click)="loadTemplates()">{{ 'WORKCLASSIFICATION.TEMPLATES.RETRY' | translate }}</button>
              } @else {
                <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.TREE.NO_TEMPLATES' | translate }}</p>
                <a *hasPermission="permissions.WorkClassificationPermissions.CanManageWorkClassification" mat-button class="btn-tertiary" [routerLink]="['/worktime', 'classification', 'templates']">
                  {{ 'WORKCLASSIFICATION.TEMPLATES.TREE.CREATE_TEMPLATE' | translate }}
                </a>
              }
              <button mat-raised-button class="btn-primary" [disabled]="templates.length === 0" (click)="openApplyTemplate()">
                {{ 'WORKCLASSIFICATION.TEMPLATES.TREE.USE_TEMPLATE_BTN' | translate }}
                <mat-icon iconPositionEnd>arrow_forward</mat-icon>
              </button>
            </mat-card-content>
          </mat-card>
          <mat-card class="info-card app-col">
            <mat-card-content class="empty-tile">
              <mat-icon class="title-icon">content_copy</mat-icon>
              <h4>{{ 'WORKCLASSIFICATION.TEMPLATES.TREE.COPY_FROM' | translate }}</h4>
              <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.TREE.COPY_FROM_DESC' | translate }}</p>
              <button mat-raised-button class="btn-primary" (click)="openCopyFromProject()">
                {{ 'WORKCLASSIFICATION.TEMPLATES.TREE.COPY_FROM_BTN' | translate }}
                <mat-icon iconPositionEnd>arrow_forward</mat-icon>
              </button>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>
    </div>
  }

  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- This node is used for non-expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [attr.data-id]="node.id" [class.highlighted]="nodeStates[node.id] === 'highlighted'">
      <button mat-icon-button disabled></button>
      <div class="node-container">

        <div class="tree-node-title" matTreeNodeToggle [ngClass]="{'CAPS':node.parentClassificationId==0}">

          {{ node.name }}
        </div>
        <div class="tree-node-subtitle faint">
          {{ node.description }}
        </div>
      </div>
      <div class="icon-button-group">
        <button mat-icon-button mat-medium-icon-button color="primary" (click)="addSubClassification(node)">
          <mat-icon class="icon-sm">add</mat-icon>
        </button>
        <button  *hasPermission="permissions.WorkClassificationPermissions.CanEditWorkClassification" mat-icon-button  mat-medium-icon-button color="primary" class="faint" (click)="editClassification(node)">
          <mat-icon class="icon-sm">edit</mat-icon>
        </button>
        @if (node.children.length <1) {
          <button *hasPermission="permissions.WorkClassificationPermissions.CanDeleteWorkClassification" mat-icon-button  mat-medium-icon-button color="warn" (click)="deleteClassification(node)">
            <mat-icon class="icon-sm">delete</mat-icon>
          </button>
        }
      </div>
    </mat-tree-node>

    <!-- This node is used for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [attr.data-id]="node.id" [class.highlighted]="nodeStates[node.id] === 'highlighted'">
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <div class="node-container">

        <div class="tree-node-title" matTreeNodeToggle [ngClass]="{'CAPS':node.parentClassificationId==0}">

          {{ node.name }}
        </div>
        <div class="tree-node-subtitle faint">
          {{ node.description }}
        </div>
      </div>
      <div class="icon-button-group">
        <button mat-icon-button mat-medium-icon-button color="primary" (click)="addSubClassification(node)">
          <mat-icon class="icon-sm">add</mat-icon>
        </button>
        <button  *hasPermission="permissions.WorkClassificationPermissions.CanEditWorkClassification" mat-icon-button  mat-medium-icon-button color="primary" class="faint" (click)="editClassification(node)">
          <mat-icon class="icon-sm">edit</mat-icon>
        </button>
        @if (node.children.length <1) {
          <button *hasPermission="permissions.WorkClassificationPermissions.CanDeleteWorkClassification" mat-icon-button  mat-medium-icon-button color="warn" (click)="deleteClassification(node)">
            <mat-icon class="icon-sm">delete</mat-icon>
          </button>
        }
      </div>
    </mat-tree-node>
  </mat-tree>

</mat-card-content>
</mat-card>
